import styled from 'styled-components';

export const CustomButton = styled.div`
text-align: center;
margin-top: 32px;
@media (min-width: 320px) and (max-width: 767px) {
    margin-top: 10px;
  }
.MuiButton-contained{
    border-radius: 4px;
    background-color: #bd0912;
    border: 1px solid #bd0912;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin: 0px 16px 0px 16px;
    cursor:pointer;
    .MuiButton-label{
        padding: 0px 24px 0px 24px;
    }
    @media (min-width: 320px) and (max-width: 767px) {
        padding: 0px 8px 0px 8px;
        font-size: 10px;
        .MuiButton-label{
            padding: 4px 6px 4px 6px;
        }
      }
}`;
